<template>
  <header
    class="app-header"
    :class="{
      'scroll-class': state.isScroll && $props.isHome,
      'is-home': $props.isHome,
      'is-normal': !$props.isHome,
    }"
  >
    <div
      class="activity-list"
      v-if="userStore.showTopAd"
      :class="{ 'no-height': !activityList.length }"
    >
      <el-carousel :initial-index="0" autoplay :interval="3000" class="notice-swiper">
        <el-carousel-item v-for="(item, index) in activityList" :key="index" class="notice-item">
          <img
            :src="item.icon?.pc?.[userStore.language] + '?x-oss-process=image/format,webp'"
            alt="item.title"
            @click="goActivityDetail(item)"
          />
        </el-carousel-item>
      </el-carousel>
      <!-- <img class="close-icon" src="@/assets/images/common/circle-close-icon.png" alt="activity-list-icon"
        @click="closeActivityList" /> -->
      <el-icon class="close-icon" @click="closeActivityList">
        <CircleCloseFilled />
      </el-icon>
    </div>
    <div class="container">
      <HeaderNav :is-home="$props.isHome" :is-scroll="state.isScroll" />
    </div>
  </header>
</template>

<script setup>
import { getBannerList } from '@/apis/logistics'
import { useUserStore } from '@/stores'
import { useWindowScroll } from '@vueuse/core'
import { defineProps, reactive, ref, watch } from 'vue'
import HeaderNav from './HeaderNav'
const { y } = useWindowScroll()
const userStore = useUserStore()
const activityList = ref([])

const $props = defineProps({
  isHome: {
    type: Boolean,
    default: false,
  },
  noNeedAdvert: {
    type: Boolean,
    default: false,
  },
  topAdvertList: {
    type: Array,
    default: () => [],
  },
})
const state = reactive({ isScroll: false })
const initActivityList = async () => {
  if ($props.noNeedAdvert) return
  if (!userStore.showTopAd) return
  const res = await getBannerList({ position: 'top', page: 'index' })
  activityList.value = res
    .map((item) => {
      return {
        ...item,
        icon: JSON.parse(item.icon),
        link: item.link ? JSON.parse(item.link) : {},
      }
    })
    .filter((item) => item.position === 'top')
}
const closeActivityList = () => {
  userStore.setShowTopAd(false)
}

const goActivityDetail = (item) => {
  if (item.jumpType === 1 && item.link?.pc) {
    window.open(item.link.pc, '_blank')
  }
}
initActivityList()

const watchYEvent = () => {
  if (y.value > 100) {
    state.isScroll = true
  } else {
    state.isScroll = false
  }
}
watch(() => y.value, watchYEvent)

watch(
  () => $props.topAdvertList,
  (newVal) => {
    activityList.value = newVal
  },
)
</script>

<style scoped lang="scss">
.app-header {
  background: transparent;
  // transition: 0.3s;
  z-index: 2000;
  // height: 80px;
  top: 0;

  .container {
    width: 100%;
    height: 80px;
  }
}

.activity-list {
  height: 88px;
  position: relative;
  transition: 0.4s;

  &.no-height {
    height: 0;

    .close-icon {
      display: none;
    }
  }

  .notice-swiper {
    width: 100%;
    height: 100%;

    ::v-deep(.el-carousel__indicators),
    ::v-deep(.el-carousel__arrow) {
      display: none;
    }

    ::v-deep(.el-carousel__button) {
      border-radius: 441px;
      height: 8px;
      width: 50px;
      margin-top: 140px;
    }

    ::v-deep(.el-carousel__container) {
      height: 100%;
    }
  }

  .close-icon {
    position: absolute;
    top: 32px;
    right: 72px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    font-size: 24px;
  }

  .notice-item {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      object-position: center;
    }
  }
}

:deep(.icon-estimate) {
  color: var(--black-color-9);
}

.is-home {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;

  :deep(.user-tab) {
    .tab-item {
      color: var(--black-common-color-9);
    }

    .activeClass {
      color: var(--primary-color);
    }

    .main {
      color: var(--primary-color);
    }
  }

  :deep(.lang-change) {
    color: var(--black-common-color-9);
  }

  :deep(.icon-diqiu) {
    color: var(--black-common-color-9);
  }

  :deep(.icon-estimate) {
    color: var(--black-common-color-9);
  }

  :deep(.icon-message) {
    color: var(--black-common-color-9);
  }

  :deep(.icon-cart) {
    color: var(--black-common-color-9);
  }

  :deep(.sign-up) {
    color: var(--black-common-color-9);
  }
}

.scroll-class {
  background: var(--white-color-1);

  :deep(.user-tab) {
    .tab-item {
      color: var(--black-color-9);
    }

    .activeClass {
      color: var(--primary-color);
    }
  }

  :deep(.lang-change) {
    color: var(--black-color-9);
  }

  :deep(.icon-diqiu) {
    color: var(--black-color-9);
  }

  :deep(.icon-estimate) {
    color: var(--black-color-9);
  }

  :deep(.icon-message) {
    color: var(--black-color-9);
  }

  :deep(.icon-cart) {
    color: var(--black-color-9);
  }

  :deep(.sign-up) {
    color: var(--black-color-9);
  }
}

.is-normal {
  position: sticky;
  background: var(--white-color-1);
  border-bottom: 1px solid #dedede;
}
</style>
